module.exports = "<example-shell\n  exampleId=\"fixed-header\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Fixed header revenue\"\n    [columns]=\"revenueColumns\"\n    [data]=\"revenue\"\n    [fixedHeader]=\"true\"\n    fixedHeaderScrollHeight=\"320px\"\n    [striped]=\"true\"\n    [highlightOnHover]=\"true\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/fixed-header/fixed-header.component.html
// module id = ./src/app/examples/fixed-header/fixed-header.component.html
// module chunks = main